export default "__VITE_ASSET__CG45yBNd__"